import React, { useEffect, useState } from "react";

import { getReferralByList } from "../../../actions/emActions";
import { imageLink } from "../../../actions/utility";
import emptyImage from "../../../public/images/empty.svg";

const ReferralTo = ({ studentId, studentName, referralCount }) => {
  const [referralList, setreferralList] = useState([]);

  useEffect(() => {
    getReferralByList(studentId).then((res) => {
      setreferralList(res.data);
    });
  }, []);

  return (
    <div className="row" id="accordionForInvoices">
      <div className="col-md-12">
        <div className="d-flex justify-content-center">
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0 "> Total Visits </label>

              <p className="font-weight-bold mb-0 paid">{referralCount} </p>
            </div>
          </div>
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0">Total Sign Ups </label>

              <p className="font-weight-bold mb-0 cancelled">{referralList.length}</p>
            </div>
          </div>
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0">Total Converted </label>

              <p className="font-weight-bold mb-0 unpaid">0</p>
            </div>
          </div>
        </div>{" "}
      </div>
      <div className="col-md-12">
        <label className="font-weight-bold mt-2">
          Who has signed up from {studentName}'s referral link:
        </label>
      </div>

      {referralList.map((item, index) => (
        <div className="col-md-12 mt-2" key={index}>
          <div className="registeredCourses d-flex justify-content-between">
            <div className="studentimgName">
              <img
                className="studentImgAvatar"
                src={
                  item?.referent_nu_users?.image !== null
                    ? imageLink(item?.referent_nu_users?.image)
                    : emptyImage
                }
              />
              <label className="">{item?.referent_nu_users?.user_name}</label>
              <label className="">
                <span className="text-muted">for</span> {item?.lm_course?.course_name}
              </label>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReferralTo;
